// extracted by css-extract-rspack-plugin
export default {"root":"uVvUhrVhNlEvp60R","actions":"aik27puyBHYKd_Z3","breadcrumbLink":"aSs958F4SQs84805"};